//
import { API } from "../../api";
async function update_delivery_data(request) {
    // console.log("update_delivery_data -> request", request);
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_BASKET_URL ?? "",
        endpoint: `v2/update/basket`, //
        content: request,
    });
}
export { update_delivery_data };
